import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Product Categories API functions
export const createProductCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.PRODUCT_CATEGORIES.CREATE, categoryData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateProductCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.PRODUCT_CATEGORIES.UPDATE}/${categoryData?.categoryId}`, categoryData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getProductCategory = async (searchInput = "", currentPage = 1, isCallFromBrand = false) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_CATEGORIES.GET}?search=${searchInput}&page=${currentPage}&isCallFromBrand=${isCallFromBrand}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllProductCategory = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_CATEGORIES.GET_ALL}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllParentProductCategory = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_CATEGORIES.GET_ALL_PARENT}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteProductCategory = async (categoryId) => {
  try {
    const response = await axiosInstance.delete(`${API_ROUTES.PRODUCT_CATEGORIES.DELETE}/${categoryId}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllCategory = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_CATEGORIES.GET_ALL_CATEGORIES}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAllCategoryLevel01 = async () => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.PRODUCT_CATEGORIES.GET_ALL_LEVET01_CATEGORIES}`);
    return response;
  } catch (error) {
    throw error;
  }
};